'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  useSections
} from "./chunk-VSTAKFRX.mjs";

// src/components/sponsors/Sponsors.tsx
import { twMerge } from "tailwind-merge";
import { ImageWithFallback } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var Sponsors = ({ sponsors, className = "" }) => {
  var _a;
  if (!sponsors) return null;
  return /* @__PURE__ */ jsx("div", { className: "space-y-6 text-center", children: (_a = sponsors == null ? void 0 : sponsors.items) == null ? void 0 : _a.map((sponsorList) => {
    var _a2, _b;
    if (!sponsorList) return null;
    return /* @__PURE__ */ jsxs("div", { className: twMerge("mx-auto max-w-4xl space-y-2", className), children: [
      sponsorList.title && /* @__PURE__ */ jsx("p", { className: "text-xl font-semibold", style: { color: sponsorList.titleColor || "" }, children: sponsorList.title }),
      /* @__PURE__ */ jsx("div", { className: "flex flex-wrap items-center justify-center gap-6", children: (_b = (_a2 = sponsorList.sponsorsCollection) == null ? void 0 : _a2.items) == null ? void 0 : _b.map((sponsor) => {
        if (!sponsor) return null;
        const Image = /* @__PURE__ */ jsx(
          ImageWithFallback,
          {
            src: sponsor.logo.url ? `${sponsor.logo.url}` : "",
            alt: sponsor.title,
            width: sponsor.logo.width,
            height: sponsor.logo.height,
            className: "h-full max-h-[80px]"
          },
          sponsor.id
        );
        if (sponsor.link) {
          return /* @__PURE__ */ jsx(
            "a",
            {
              href: sponsor.link,
              target: "_blank",
              rel: "noreferrer",
              className: "transition hover:scale-105",
              children: Image
            },
            sponsor.id
          );
        }
        return Image;
      }) })
    ] }, sponsorList.id);
  }) });
};
var Sponsors_default = Sponsors;

// src/components/sponsors/SponsorList.tsx
import { Typography } from "@wbk/ui";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var SponsorList = ({ section }) => {
  const sponsorList = section.contentCollection;
  return /* @__PURE__ */ jsxs2(
    DecoratedSection_default,
    {
      section,
      "data-testid": `sponsors_list_${section.id}`,
      className: "container",
      children: [
        section.title && /* @__PURE__ */ jsxs2("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx2(Typography, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx2(Typography, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx2(Sponsors_default, { sponsors: sponsorList, className: "max-w-full" })
      ]
    }
  );
};
var SponsorList_default = SponsorList;

// src/components/sponsors/SponsorsAsync.tsx
import { useRouter } from "@wbk/config";
import { jsx as jsx3 } from "react/jsx-runtime";
var SponsorsSectionAsync = ({ id, className, fallbackSponsors }) => {
  var _a;
  const { locale } = useRouter();
  const { data } = useSections({ limit: 1, lang: locale, where: { id } });
  const section = (_a = data == null ? void 0 : data.items) == null ? void 0 : _a[0];
  if (!section && !(fallbackSponsors == null ? void 0 : fallbackSponsors.items.length)) return null;
  if (!section) {
    return /* @__PURE__ */ jsx3("section", { className, children: /* @__PURE__ */ jsx3(Sponsors_default, { sponsors: fallbackSponsors }) });
  }
  return /* @__PURE__ */ jsx3("section", { className, children: /* @__PURE__ */ jsx3(SponsorList_default, { section }) });
};
var SponsorsAsync_default = SponsorsSectionAsync;

export {
  Sponsors_default,
  SponsorList_default,
  SponsorsAsync_default
};
//# sourceMappingURL=chunk-FM4Y3V2B.mjs.map